export const HEADER_ICON_SIZES = {
  iconSize: 16,
  facilityDetailsiconSize: 20,
  socialiconSize: 24,
  CTAButtoniconSize: 20,
  CTAButtoniconSizeTopBarTwoAndThree: 16,
  navBarIconFontSize: 30,
};
